import React, { useState } from 'react';
import { Row, Col, Label, Input, Button, Spinner } from 'reactstrap';
import { toast } from 'react-toastify';
import MemberMembershipService from '../../../../../../services/member_membership_service';
import ConfirmDialog from '../../../../../../components/Common/ConfirmDialog';

import { toISODate, formatDate } from "../../../../../../utils/date";

const ActionAddDays = ({ activeAction, membership, idTenant, user, onRefresh }) => {
    const [daysCount, setDaysCount] = useState("");
    const [reason, setReason] = useState("");
    const [loading, setLoading] = useState(false);

    const isAdd = activeAction === "addDays";
    const actionName = isAdd ? "Adicionar" : "Remover";
    const iconClass = isAdd ? "mdi-calendar-plus" : "mdi-calendar-minus";

    const handleApply = async () => {
        const n = parseInt(daysCount, 10);
        if (!n || n <= 0) return toast.warning("Informe um número de dias válido.");
        
        if (!isAdd) {
            const ok = await ConfirmDialog({
                title: "Confirmar Redução?",
                text: `Esta ação antecipará o vencimento. Tem certeza que deseja remover ${n} dia(s)?`,
                confirmButtonText: "Sim, confirmar",
            });
            if (!ok) return;
        }

        setLoading(true);
        try {
            const d = new Date(membership.endDate + "T23:59:59");
            d.setDate(d.getDate() + (isAdd ? n : -n));
            
            await MemberMembershipService.update(membership.id, idTenant, user, {
                endDate: toISODate(d),
                updatedReason: reason || (isAdd ? "Adição manual de dias" : "Remoção manual de dias")
            });
            
            toast.success(`Ajuste concluído: ${n} dia(s) ${isAdd ? 'adicionado(s)' : 'removido(s)'}.`);
            setDaysCount("");
            setReason("");
            if (onRefresh) onRefresh();
        } catch (error) { 
            toast.error(`Erro ao ${actionName.toLowerCase()} dias.`);
            console.error(error);
        } finally { 
            setLoading(false); 
        }
    };

    const currentEndDateStr = formatDate(membership.endDate);
    let newEndDateStr = "---";

    if (daysCount && !isNaN(daysCount) && daysCount > 0) {
        const dt = new Date(membership.endDate + "T00:00:00");
        dt.setDate(dt.getDate() + (isAdd ? +daysCount : -daysCount));
        newEndDateStr = formatDate(toISODate(dt));
    }

    return (
        <div className="p-4 border rounded-0 mt-3 bg-white">
            <div className="d-flex align-items-center mb-3">
                <i className={`mdi ${iconClass} fs-4 me-2 text-muted`}></i>
                <h6 className="fw-bold mb-0 text-dark text-uppercase" style={{ letterSpacing: "0.5px" }}>
                    {isAdd ? "Adicionar Dias ao Contrato" : "Reduzir Dias do Contrato"}
                </h6>
            </div>
            
            <p className="text-muted font-size-13 mb-4">
                {isAdd 
                    ? "Utilize esta função para conceder cortesias, dias compensatórios ou tratar exceções administrativas. O vencimento será estendido."
                    : "Utilize esta função para encurtar a validade do contrato devido a pendências, recálculos ou acordos firmados com o aluno."}
            </p>

            <Row className="g-3 align-items-start">
                <Col md={3}>
                    <Label className="font-size-12 fw-medium text-dark mb-1">Quantidade (Dias)</Label>
                    <Input 
                        type="number" 
                        bsSize="sm" 
                        min="1" 
                        placeholder="Ex: 5"
                        value={daysCount} 
                        onChange={e => setDaysCount(e.target.value)} 
                        className="py-2 bg-light border-0"
                    />
                </Col>
                <Col md={6}>
                    <Label className="font-size-12 fw-medium text-dark mb-1">Motivo (Para auditoria)</Label>
                    <Input 
                        type="text" 
                        bsSize="sm" 
                        placeholder="Descreva a razão do ajuste..."
                        value={reason} 
                        onChange={e => setReason(e.target.value)} 
                        className="py-2 bg-light border-0"
                    />
                </Col>
                <Col md={3} className="d-flex align-items-end" style={{ height: "62px" }}>
                    <Button 
                        color="dark" 
                        className="w-100 fw-medium font-size-13 d-flex align-items-center justify-content-center rounded-0"
                        style={{ height: "36px" }}
                        onClick={handleApply}
                        disabled={loading || !daysCount || daysCount <= 0}
                    >
                        {loading ? <Spinner size="sm" /> : "Confirmar"}
                    </Button>
                </Col>
            </Row>

            {daysCount > 0 && (
                <div className="mt-4 pt-3 border-top">
                    <Label className="font-size-11 text-muted text-uppercase mb-2 fw-bold" style={{ letterSpacing: "0.5px" }}>
                        Impacto no Vencimento do Plano
                    </Label>
                    <div className="d-flex align-items-center bg-light p-3 rounded-0">
                        <div className="flex-grow-1 text-center">
                            <div className="text-muted font-size-11 text-uppercase mb-1">Data Atual</div>
                            <div className="fw-bold font-size-15 text-dark">{currentEndDateStr}</div>
                        </div>
                        <div className="px-3 text-muted">
                            <i className="mdi mdi-arrow-right fs-4"></i>
                        </div>
                        <div className="flex-grow-1 text-center">
                            <div className="text-muted font-size-11 text-uppercase mb-1">Nova Data</div>
                            <div className="fw-bold font-size-15 text-dark">{newEndDateStr}</div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ActionAddDays;
